import { SignedDistanceField } from '../../../core/models/SignedDistanceField';
import { CustomObject } from './CustomObject';
import { ImageObject } from '../../image/ImageObject';
import { Grid } from '../Grid';

/**
 * Abstract class for objects that are used as targets by a Tool
 */
export abstract class CustomTargetObject extends CustomObject {
    protected _grid: Grid;

    protected readonly _targetImage: ImageObject;

    protected readonly _imageGrid: Grid;

    /**
     * {@link SignedDistanceField} that stores the {@link WebGLTexture} with signed distance values.
     */
    protected sdf?: SignedDistanceField;

    protected constructor(image: ImageObject) {
        super();
        this._targetImage = image;
        this._imageGrid = image.parent.grid;
        this._grid = new Grid(
            0,
            0,
            0,
            this._imageGrid.resX,
            this._imageGrid.resY,
            this._imageGrid.resZ,
            null
        );
    }

    /**
     * Method to retrieve the {@link WebGLTexture} stored within the {@link sdf} of this {@link CustomTargetObject}.\
     * This method will return undefined if the {@link CustomTargetObject} has not been {@link update updated} yet.
     * @returns Reference to texture.
     */
    public get texture(): WebGLTexture | undefined {
        return this.sdf?.texture;
    }

    public get grid(): Grid {
        return this._grid;
    }

    /**
     * Method to delete this {@link CustomTargetObject}.\
     * This will {@link SignedDistanceField.delete delete} the {@link sdf}.\
     * It is important to call this method when the {@link CustomTargetObject} is no longer needed.\
     * This method may be overridden by subclasses to delete additional resources. However the super method should always be called.
     * @returns True to indicate that the {@link CustomTargetObject} was successfully deleted.
     */
    public delete() {
        if (this.sdf) {
            this.sdf.delete();
        }
    }
}
